/**
 * Waits for a dependency to be present before resolving
 * @param {function} test - A function that looks for the dependency, and returns it, if found
 * @param {number} timeout - Amount of time to wait before timing out, in ms
 * @param {number} frequency - How frequent to look for the dependency, in ms
 * @example
 * waitForDependency(() => window.someGlobal);
 */
export default function waitForDependency(test, timeout = 5000, frequency = 100) {
  return new Promise((resolve, reject) => {
    let duration = 0;
    let intervalId;

    if (typeof test !== 'function') reject(new Error('test parameter is not a function'));

    function complete(response) {
      window.clearInterval(intervalId);
      if (response) {
        resolve(response);
      } else {
        reject(new Error('Library not found'));
      }
    }

    intervalId = window.setInterval(() => {
      duration += frequency;
      const value = test();
      if ((duration > 0) && (duration > timeout)) {
        complete();
        return;
      }

      if (value !== undefined) complete(value);
    });
  });
}
